import React, { Component } from "react";
import {
  aggregateSum,
  aggregateAverage,
  aggregateMaximum,
  aggregateMinimum,
} from "../helpers/groupedRowAggregates";

import { AiFillCaretDown } from "react-icons/ai";

import COLORS from "scss/colors.module.scss";

export default class GroupedNumberCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupVisible: false,
      aggregateType: "Sum",
      value: aggregateSum(props.node.allLeafChildren, props.colDef.field),
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  getListItem(name, callback) {
    return (
      <div className="aggregateOption" onClick={callback}>
        <div className="aggregateOptionName">{name}</div>
      </div>
    );
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (
      this.state.popupVisible &&
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target)
    ) {
      this.setState({ popupVisible: false });
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }

  render() {
    return (
      <div
        className="groupedCellContainer"
        onClick={() => {
          if (!this.state.popupVisible) this.setState({ popupVisible: true });
        }}
        style={{
          width: Number(this.props.colDef.width),
          height: this.props.node.rowHeight,
        }}
      >
        <div style={{ color: COLORS.AGGREGATE_TYPE, paddingLeft: 10 }}>
          {this.state.aggregateType}
        </div>
        <div
          style={{
            textAlign: "end",
            paddingLeft: 10,
            paddingRight: 10,
          }}
        >
          {this.state.value}
        </div>
        <div className="groupedCellDownArrow">
          <AiFillCaretDown />
        </div>
        <div
          ref={this.setWrapperRef}
          style={{
            ...styles.menu,
            minWidth: Number(this.props.colDef.width),
            display: this.state.popupVisible ? "flex" : "none",
            top: this.props.node.rowHeight,
          }}
        >
          {this.getListItem("Sum", () => {
            this.setState({
              popupVisible: false,
              aggregateType: "Sum",
              value: aggregateSum(
                this.props.node.allLeafChildren,
                this.props.colDef.field
              ),
            });
          })}
          {this.getListItem("Average", () => {
            this.setState({
              popupVisible: false,
              aggregateType: "Average",
              value: aggregateAverage(
                this.props.node.allLeafChildren,
                this.props.colDef.field
              ),
            });
          })}
          {this.getListItem("Minimum", () => {
            this.setState({
              popupVisible: false,
              aggregateType: "Minimum",
              value: aggregateMinimum(
                this.props.node.allLeafChildren,
                this.props.colDef.field
              ),
            });
          })}
          {this.getListItem("Maximum", () => {
            this.setState({
              popupVisible: false,
              aggregateType: "Maximum",
              value: aggregateMaximum(
                this.props.node.allLeafChildren,
                this.props.colDef.field
              ),
            });
          })}
        </div>
      </div>
    );
  }
}

const styles = {
  menu: {
    position: "absolute",
    top: 0,
    zIndex: 4444,
    backgroundColor: COLORS.SECONDARY_COLOR,
    minHeight: 100,
    flexDirection: "column",
  },
};
